(() => {
    class Translation {
        constructor() {
            this.Storage    = new App.Interface.Storage('translation');
            this.async      = true; // Use placeholder when true (beta)
            this.queue      = [];
            App.load(() => this.apply());
        }

        get url() {
            let url = '/interface/translation/'; // user magic because some race condition problems
            if (App.language) url = App.language + url;
            return url;
        }

        get(key) {
            let translation = App.Data.getTranslation(key) || this.Storage.get(key);
            if (!translation) {
                translation = this.placeholder(key);
                if (!this.queue.includes(key)) {
                    this.queue.push(key);
                    this.request();
                }
            }
            return translation;
        }

        request() {
            if (this.timeOut) clearTimeout(this.timeOut);
            this.timeOut = setTimeout(() => {
                /* Make the AJAX-call. */
                $.ajax({
                    url:        this.url + this.queue.join(),
                    async:      this.async,
                    dataType:   'html',
                }).done(response => {
                    response = JSON.parse(response);
                    for (const identifier in response) {
                        const index = this.queue.indexOf(identifier);
                        if (index !== -1) this.queue.splice(index, 1);
                        this.Storage.set(identifier, response[identifier]);
                    }
                    App.Layout.refresh();
                });
            }, 100);
        }

        replacePlaceholder(key, translation) {
            // Search for DOM element
            App.setInterval(() => {
                document.querySelector('translation[data-key="' + key + '"]').outerHTML = translation;
            }, 500);
            return this;
        }

        placeholder(key) {
            return '<translation data-key="' + key + '" ></translation>';
        }

        set(key, translation) {
            this.Storage.set(key, translation);
            return this;
        }

        /** @deprecated Use promise AKA _() */
        retrieve(key) {
            return App.Interface.Translation.get(key.trim());
        }

        async promise(key) {
            let translation = App.Data.getTranslation(key) || this.Storage.get(key);
            if (!translation) {
                return await fetch(this.url + key)
                    .then(async response => {
                        const translation = JSON.parse(await response.text())[key];
                        this.Storage.set(key, translation);
                        return translation;
                    });
            }
            return translation;
        }

        apply() {
            document.querySelectorAll('translation[data-key]').forEach(placeholder => {
                placeholder.outerHTML = this.get(placeholder.dataset.key);
            });
        }

    }
    App.Interface.Translation = new Translation();
})();
